import { Link } from "react-router-dom";
import { HOME_URL_LOCAL } from "../../../utility/BaseUrl";
import { formatNumber } from "../../../utility/Formater";
import ShoppingBoxViewProductComponent from "./ShoppingBoxViewProductComponent";

export default function PageOrderComponent({
  handleNextProcess,
  cart,
  setData,
}) {
  return (
    <>
      {cart.items.length > 0 ? (
        <div>
          <div className="page-description cart-description">
            فهرست محصولاتی که به سبدخرید اضافه کردید را در زیر مشاهده می‌کنید.
          </div>
          <div className="cart-items">
            {cart.items.map((item, index) => {
              if (item.product) {
                return (
                  <ShoppingBoxViewProductComponent
                    key={index}
                    pro={item.product}
                    item={item}
                    setData={setData}
                  />
                );
              }
            })}
          </div>
          <hr className="page-separator cart-separator" />
          <div className="row">
            <div className="col-lg-6">
              {/* <form name="coupons" className="cart-coupons ">
                        <div className="form-group cart-coupons-code">
                          <div className="input-group cart-coupons-code-group">
                            <input
                              type="text"
                              className="form-control cart-coupons-code-input ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched"
                              name="code"
                              ng-model="model.code"
                              ng-disabled="progress"
                              placeholder="کوپن تخفیف خود را بنویسید..."
                              required
                            />
                            <div className="input-group-append mr-10">
                              <button
                                className="btn btn-light text-dark cart-coupons-code-btn"
                                ng-disabled="progress"
                              >
                                اعمال
                              </button>
                            </div>
                          </div>
                          <div className="validation-inline cart-coupons-inline-error text-danger ">
                            ngMessage: required
                            <span>کوپن تخفیف را بنویسید.</span>
                            ngMessage: server
                          </div>
                          <div className="cart-coupons-items ">
                            ngRepeat: coupon in $parent.model.coupons
                          </div>
                        </div>
                      </form> */}
              <hr className="page-separator cart-separator d-lg-none" />
            </div>
            <div className="col-lg-6">
              <table className="table table-bordered table-striped cart-details">
                <tbody>
                  {/* <tr className="cart-details-subtotal">
                              <th className="cart-details-subtotal-label">
                                جمع کل
                              </th>
                              <td className="cart-details-subtotal-value ">
                                30,300,000 تومان
                              </td>
                            </tr> */}
                  {/* <tr className="cart-details-tax">
                              <th className="cart-details-tax-label">مالیات</th>
                              <td className="cart-details-tax-value ">
                                0 تومان
                              </td>
                            </tr>
                            <tr className="cart-details-discount">
                              <th className="cart-details-discount-label">
                                تخفیف
                              </th>
                              <td className="cart-details-discount-value text-red ">
                                0 تومان
                              </td>
                            </tr> */}
                  <tr className="cart-details-total">
                    <th className="cart-details-total-label">قابل پرداخت</th>
                    <td className="cart-details-total-value text-green ">
                      {formatNumber(cart.total)} تومان
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                type="button"
                className="btn btn-lg btn-primary btn-block btn-arrow-left rounded mt-25"
                onClick={handleNextProcess}
              >
                ثبت سفارش
              </button>
              {/* <SaveOrderComponent /> */}
            </div>
          </div>
        </div>
      ) : (
        <div className="cart-empty ">
          <div className="page-description cart-empty-description">
            <mark className="cart-empty-description-text">
              سبدخرید شما خالی است. برای افزودن محصولات دلخواه خود به صفحه‌ی
              فروشگاه مراجعه کنید.
            </mark>
          </div>
          <Link
            to={HOME_URL_LOCAL}
            className="btn btn-primary btn-sm cart-empty-link"
          >
            خانه
          </Link>
        </div>
      )}
    </>
  );
}
